import { STORAGE_KEYS } from 'constants';
import { modal, notification } from 'utils/escapeAntd';
import { Storage } from "utils/storage";
import Cookies from 'js-cookie';

// - 다국어 사용안함
// 다국어 hook 없이 사용  
// export function I18N(value) {
//   return <Translation>{(t) => <span>{t(value)}</span>}</Translation>;
// }

// content: 메시지, config: 옵션변경 시 사용
export const AlertMsg = (content, config) => {
  modal.info({
    title: '', //<Button className="ant-modal-close" />,
    closable: true,
    okText: '확인',
    icon: null,
    width: 360,
    content: content || '',
    ...config
  });
};

// content: 메시지, config: 옵션변경 시 사용
export const ConfirmMsg = (content, config) => {
  modal.confirm({
    title: '',
    closable: true,
    okText: '확인',
    cancelText: '취소',
    icon: null,
    width: 360,
    content: content || '',
    ...config
  });
};

// type, 타입, message: 메시지, config: 옵션변경 시 사용
export const ToastMsg = (type, message, config) => {
  const option = {
    placement: 'bottomLeft', 
    message: message || '',
    duration: 2,
    ...config
  }
  if(type === 'success') {
    notification.success(option);
  } else if(type === 'error') {
    notification.error(option);
  } else if(type === 'info') {
    notification.info(option);
  } else if(type === 'warning') {
    notification.warning(option);
  }
};

// 모든 Storage 초기화
export const InitStorage = () => {
  Storage.session.remove(STORAGE_KEYS.USERINFO);
  Storage.session.remove("jwt");
};

export const setStorageUserInfo = (data) => {
  Storage.session.set(STORAGE_KEYS.USERINFO, data);
};

export const getStorageUserInfo = () => {
  if(Cookies?.get('loginInfo')){
    return JSON.parse(Cookies?.get('loginInfo'));
  }
  
  //return Storage.session.get(STORAGE_KEYS.USERINFO);
};

export const setStorageJwtInfo = (data) => {
  Storage.session.set("jwt", data);
};

export const getStorageJwtInfo = () => {
  return Storage.session.get("jwt");
};

export const handleFileDownload = (data, fileName) => {
  if(!data) return;
  const blob = new Blob([data]);
  const fileUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = fileUrl;
  link.style.display = 'none';
  link.download = fileName || '';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(fileUrl);
};

export const handleFileDownloadExcel = (data, fileName) => {
  if(!data) return;
  
  // Blob 생성 시 MIME 타입 지정
  const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
  const fileUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = fileUrl;
  link.style.display = 'none';
  link.download = fileName || 'download.xlsx'; // 기본 파일명 지정
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(fileUrl);
};





// 숫자에 콤마찍기
export const formatNumber = (value) => new Intl.NumberFormat().format(value);

// 전화번호 포맷팅
export const formatPhoneNumber = (phone) => {
  if (!phone) return "";

  // 숫자만 남기기
  const cleaned = phone.replace(/\D/g, "");

  if (cleaned.length === 11) {
    // 01012345678 → 010-1234-5678
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  } else if (cleaned.length === 10) {
    if (cleaned.startsWith("02")) {
      // 0212345678 → 02-1234-5678
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
    } else {
      // 0311234567 → 031-123-4567
      return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    }
  } else if (cleaned.length === 9 && cleaned.startsWith("02")) {
    // 021234567 → 02-123-4567
    return cleaned.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
  }

  // 포맷 불가할 경우 원본 반환
  return phone;
}